import React, { useRef } from 'react';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
import { SideNavVM } from './SideNavVM';
import stores from 'cd-eft/models/Stores';
import { NavLink, useLocation } from 'react-router-dom';
import ArrowBackIcon from '../../../assets/images/arrow_back_ios-white-18dp.svg';
import {
  mdiBookshelf,
  mdiPencilRuler,
  mdiHome,
  mdiHelpCircleOutline,
  mdiBookOpenOutline,
  mdiCubeOutline,
  mdiChevronLeft,
  mdiLogoutVariant,
  mdiAccountMultiple
} from '@mdi/js';
import './sideNav.scss';
import { useHistory } from 'react-router-dom';
import MessageCenter from '../MessageCenter/MessageCenterVM';
import { UserIdentity } from 'cd-eft/security/UserIdentity';
import { LeftSideAnalysisMenu } from './SubNavigation/LeftSideAnalysisMenu';
import { LeftSideAdminMenu } from './SubNavigation/LeftSideAdminMenu';

const { AppStore } = stores;

const SideNavComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const vm = useRef(new SideNavVM(history, location)).current;

  if (vm.history.location.pathname === '/glossary' || vm.history.location.pathname === '/ugomateriallist') {
    return (
      <nav id="sidebar" role="navigation">
        {vm.glossaryHelpClicked === false ? vm.toggleGlossaryHelpBack : null}
        <button className="usa-button toggle-sidebar usa-button-sidenav" onClick={vm.toggleGlossaryHelpBack}>
          <img src={ArrowBackIcon} alt={`${vm.sidebarActive ? '' : 'back icon'}`} />
          Back
        </button>
      </nav>
    )
  }
  else if (vm.history.location.pathname.includes('/analysis')) {
    return (
      <div className='nav-combined-container'>
        <StandardNavBar vm={vm} />
        <LeftSideAnalysisMenu />
      </div>
    );
  }
  else if (vm.history.location.pathname.includes('/admin')) {
    return (
      <div className='nav-combined-container'>
        <StandardNavBar vm={vm} />
        <LeftSideAdminMenu />
      </div>
    )
  }
  else return (
    <StandardNavBar vm={vm} />
  );
};

export const SideNav = observer(SideNavComponent);

// Links and SubLinks
const SideLink = (props) => {
  const { url, path, iconTitle, title, children, exact = false, projectClassId, sidebarActive } = props;
  const onClick =
    projectClassId !== undefined
      ? () => {
        AppStore.createProjectClassId = projectClassId;
        MessageCenter.clearMessages();
      }
      : () => MessageCenter.clearMessages();
  return (
    <li>
      <NavLink to={url} activeClassName="active-link" className="sidebar-button" exact={exact} onClick={onClick}>
        <div className="sidebar-button-title-container">
          <div className="sidebar-button-img">
            {sidebarActive ? <Icon path={path} size={1.2} /> : <Icon path={path} title={iconTitle} size={1.2} />}
          </div>
          <div className="sidebar-button-title nobr">{title}</div>
        </div>
      </NavLink>
      {children}
    </li>
  );
};

const SideSubLink = (props) => {
  const { url, title, children, projectClassId, exact } = props;
  const onClick =
    projectClassId !== undefined
      ? () => {
        AppStore.createProjectClassId = projectClassId;
        MessageCenter.clearMessages();
      }
      : () => MessageCenter.clearMessages();
  return (
    <li>
      <NavLink to={url} activeClassName="active-link" onClick={onClick} exact={exact}>
        <div className="sidebar-button-title">{title}</div>
      </NavLink>
      {children}
    </li>
  );
};

const StandardNavBar = observer((props) => {
  return (
    <nav className={`${props.vm.sidebarActive ? '' : 'collapsed'}`} id="sidebar" role="navigation" aria-label="Main Menu">
      <ul className='m-0'>
        <SideLink
          url="/"
          path={mdiHome}
          iconTitle="Home"
          title="Homepage"
          exact={true}
          sidebarActive={props.vm.sidebarActive}
        />
        <SideLink
          url="/projects"
          path={mdiBookshelf}
          iconTitle="Projects"
          title="Project Library"
          projectClassId={0}
          sidebarActive={props.vm.sidebarActive}
        />
        <SideLink
          url="/design"
          path={mdiPencilRuler}
          iconTitle="Design"
          title="Design"
          projectClassId={1}
          sidebarActive={props.vm.sidebarActive}
        />
        <SideLink
          url="/analysis"
          path={mdiCubeOutline}
          iconTitle="Analysis"
          title="Analysis"
          sidebarActive={props.vm.sidebarActive}
        />
        {/* <SideLink url="/dashboard" path={mdiViewDashboard} iconTitle="Dashboard" title="Dashboard" /> */}
        <SideLink
          url="/training"
          path={mdiBookOpenOutline}
          iconTitle="Training"
          title="Training"
          sidebarActive={props.vm.sidebarActive}
        />
        {stores.AppStore.userProfileStore.applicationFlags.enableadminrole && (UserIdentity.userRoleId && (UserIdentity.userRoleId === 4 || UserIdentity.userRoleId === 3)) ?
          < SideLink
            url="/admin"
            path={mdiAccountMultiple}
            iconTitle="Admin"
            title="Admin"
            sidebarActive={props.vm.sidebarActive}
          />
          : null}
      </ul>

      <div>
        {!stores.AppStore.appConfig.useEAuth ? (
          <NavLink to="/login" title='Logout' className="sidebar-button logout-button" onClick={props.vm.onLogout}>
            <div className="sidebar-button-img">
              <Icon path={mdiLogoutVariant} size={1.2} color="#ffffff" />
            </div>
            <div className="sidebar-button-title">Logout</div>
          </NavLink>
        ) : null}
        {stores.AppStore.appConfig.enableGlossaryService ? (
          <NavLink
            to="/glossary"
            title="Glossary / Help"
            className={"sidebar-button help-button"}
            onClick={props.vm.toggleGlossaryHelpIcon}
          >
            <div className="sidebar-button-img">
              <Icon path={mdiHelpCircleOutline} size={1.2} color="#ffffff" />
            </div>
            <div className="sidebar-button-title">Glossary / Help</div>
          </NavLink>
        ) : null}



        <NavLink
          to="/"
          title={`${props.vm.sidebarActive ? '' : 'extend sidebar'}`}
          className="sidebar-button toggle-sidebar-button"
          onClick={props.vm.toggleSideNav}
          aria-current='page'
        >
          <div className="sidebar-button-img">
            <Icon path={mdiChevronLeft} size={1.2} color="#ffffff" />
          </div>
          <div className="sidebar-button-title ">Collapse Sidebar</div>
        </NavLink>
      </div>
    </nav>
  );
})